/**
 * punchoutNeedToken 当前页面是否需要登录
 * punchoutfailedLogin punchoutNeedToken 的token没有时 需要跳转的页面
 * **/
const punchoutLogin = {
  path: '/punchout-login',
  component: () => import('@/views/modules/punchout/login'),
  name: 'punchoutLogin',
  meta: {
    title: 'punchout登录'
  }
}
const punchoutOtherLogin = {
  path: '/punchoutOtherLogin',
  component: () => import('@/views/modules/punchout/simulation'),
  name: 'punchoutOtherLogin',
  meta: {
    title: '模拟登陆页'
  }
}
const punchoutMain = {
  path: '/punchout-index',
  component: () => import('@/views/modules/punchout/main'),
  name: 'punchoutMain',
  meta: {
    title: '首页',
    punchoutNeedToken: true,
    punchoutfailedLogin: 'punchoutLogin'
  },
  children: [
    {
      path: '/punchout-index',
      component: () => import('@/views/modules/punchout/index'),
      name: 'punchoutIndex',
      meta: {
        title: '首页',
        punchoutNeedToken: true,
        punchoutfailedLogin: 'punchoutLogin'
      }
    },
    {
      path: '/punchout-goods-list',
      component: () => import('@/views/modules/punchout/goodsList'),
      name: 'punchoutGoodsList',
      meta: {
        title: '商品列表',
        punchoutNeedToken: true,
        punchoutfailedLogin: 'punchoutLogin'
      }
    },
    {
      path: '/punchout-goods-detail',
      component: () => import('@/views/modules/punchout/goodsDetail'),
      name: 'punchoutGoodsDetail',
      meta: {
        title: '商品详情',
        punchoutNeedToken: true,
        punchoutfailedLogin: 'punchoutLogin'
      }
    },
    {
      path: '/punchout-shop-cart',
      component: () => import('@/views/modules/punchout/shopCart'),
      name: 'punchoutShopCart',
      meta: {
        title: '购物车',
        punchoutNeedToken: true,
        punchoutfailedLogin: 'punchoutLogin'
      }
    },
    {
      path: '/punchout-order-list',
      component: () => import('@/views/modules/punchout/orderList'),
      name: 'punchoutOrderList',
      meta: {
        title: '订单列表',
        punchoutNeedToken: true,
        punchoutfailedLogin: 'punchoutLogin'
      }
    },
    {
      path: '/punchout-order-detail',
      component: () => import('@/views/modules/punchout/orderDetail'),
      name: 'punchoutOrderDetail',
      meta: {
        title: '订单详情',
        punchoutNeedToken: true,
        punchoutfailedLogin: 'punchoutLogin'
      }
    },
    {
      path: '/punchout-submit-order',
      component: () => import('@/views/modules/punchout/submitOrder'),
      name: 'punchoutSubmitOrder',
      meta: {
        title: '提交预订单',
        punchoutNeedToken: true,
        punchoutfailedLogin: 'punchoutLogin'
      }
    }
  ]
}
module.exports = {
  punchoutLogin,
  punchoutMain,
  punchoutOtherLogin
}
